<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <app-customerlist :contactPageData='contactPage'></app-customerlist>
        <app-footer></app-footer>
    </div>
</template>

<script>


    // import { headers } from "../config";
    import {list_customerUrl, configs} from '../../config';
    import EventBus from '../event-bus';
    import SessioMixin from '../../mixins/sessionmixin';
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import FrontFooter from '@/components/partials/FrontFooter';
    import ListCustomerComponent from "@/components/customer/ListCustomerComponent";

    Vue.use(VueGoodTable);

    export default {
        name: "listCustomer",
        mixins: [SessioMixin],
        components: {
            'app-footer': FrontFooter,
            'app-customerlist': ListCustomerComponent,
        },
        data: () => ({
                contactPage: {
                    pageTitle: 'Customer List',
                },
                isLoggedIn: false,
            }),

        mounted: function () {
            var self = this;
            $(".removeActive").removeClass('active');
            $("#menucustomers").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            self.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                app.isLoggedIn = true;
            }
        },
        methods: {
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    };
</script>
<style>
    .vgt-checkbox-col input {
        opacity: 1 !important;
        position: static !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/customer/ListCustomer.vue